import { Popup } from "antd-mobile"
import { PureComponent } from "react";
import {SOURCE} from "@src/config/index";
import './customScroll/index.scss'
import {point,periods} from "@src/assets/JSON/Picker.json";

type PickerType = {
  thisVal:any[]
}

export default class PickerPopup extends PureComponent<any,PickerType> {

  constructor(props:any){
    super(props);
    this.state = {
      thisVal:[]
    }
  }
  componentDidUpdate(oldProps: any) {
    // 拿取父组件的值
    if(oldProps.visible !== this.props.visible){
      this.setState({
        thisVal:[...this.props.value]
      })
    }
  }

  /**
   * 选择
   * @param va item 
   * @param type  0,1
   */
  setPicker(va:any,type:number){
    const {thisVal} = this.state;

    thisVal[type] = va.value;
    
    this.setState({
      thisVal: [...thisVal]
    })
    
  }

  // 提交给父组件
  submit(va: any) {
    this.props.setVal(va);
    this.props.setVisible(false);
  }

  render() {
    const {visible, setVisible,carPrice} = this.props;
    const {thisVal} = this.state;
    return(<div>
      <Popup
       bodyStyle={{
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px'
      }}
      visible={visible}
      onMaskClick={() => {
        setVisible(false)
      }}
       >
        <div className="PickerPopup">
          <h1>首付比例</h1>
          <ul>
            {
              point&&point.map(_ele=>(
                <li style={{display:(SOURCE=="cfmoto"&&_ele.value==0)?'none':"block"}} key={_ele.value} onClick={()=>this.setPicker(_ele,0)} className={thisVal[0]==_ele.value?'check':""}>
                  {_ele.label}
                </li>
              ))
            }
          </ul>
        </div>
        <div className="PickerPopup">
          <h1>期数</h1>
          <ul>
          {
              periods&&periods.map(_ele=>(
                <li style={{display:(carPrice < 30000&&_ele.value==36)?'none':"block"}} key={_ele.value} onClick={()=>this.setPicker(_ele,1)} className={thisVal[1]==_ele.value?'check':""}>
                  {_ele.label}
                </li>
              ))
            }
          </ul>
        </div>
        <div className="Pickerbtn bottomFit">

          <div onClick={()=>this.submit(thisVal)} className="button-them" >确认</div>
          {/* <div onClick={()=>setVisible(false)} className="revBtn">取消</div> */}
        </div>
      </Popup>
    </div>)
  }
}

